<template>
  <v-card-text class="pa-0 d-flex flex-column" style="height: 90%;min-height: 600px;">
    <Questions
      ref="sq19q0"
      @goToNextQuestion="goToNextQuestion"
      :isCurrency="false"
      :dataSeted="dataSeted"
      :question="questionData.questions[0]"
      :screens_question="questionData.question"
      :sq_aclaration="questionData.aclaration"
      @sendAnswer="versionSelected"
      @changeDataSeted="changeDataSeted">
    </Questions>
    <transition name="ques">
      <NextQuestionButton
        v-if="showButton"
        @goToNextQuestion="goToNextQuestion">
      </NextQuestionButton>
    </transition>
  </v-card-text>
</template>

<script>
import Questions from '@/components/savings/blocks/Questions'
import NextQuestionButton from '@/components/savings/blocks/NextQuestionButton'
import { mapGetters } from 'vuex'
import { answerData } from '@/mixins/answerData'

export default {
  name: 'SQuesNineteen',
  components: {
    Questions,
    NextQuestionButton
  },
  props: {
    questionData: Object
  },
  data () {
    return {
      showButton: false,
      dataSeted: false,
      question0: '',
      historyFirstValue: [],
      historyScrap: [],
      sq_data: [
        {
          question_id: this.questionData.questions[0].id,
          ponderation: '',
          updated_at: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getOperationNumber',
      'scoringData',
      'isBrowsingInScoringHistory',
      'continueScoring',
      'getIndexOfCurrentSQ',
      'getHistory',
      'SQNameByNumber',
      'sq_number'
    ])
  },
  methods: {
    setData () {
      if (this.scoringData.sq_nineteenData !== null) {
        this.showButton = true
        this.$emit('handleProgress', 19)
        this.$refs.sq19q0.setAnswer(this.scoringData.sq_nineteenData[0].ponderation)
        this.sq_data[0].ponderation = this.scoringData.sq_nineteenData[0].ponderation
        this.sq_data[0].updated_at = this.scoringData.sq_nineteenData[0].updated_at
        if (this.continueScoring) {
          if (this.scoringData.sq_nineteenData[0].id !== undefined) {
            this.sq_data[0].id = this.scoringData.sq_nineteenData[0].id
          }
        }
        if (this.isBrowsingInScoringHistory) {
          this.question0 = this.scoringData.sq_nineteenData[0].ponderation
          this.historyFirstValue = this.getHistory
        }
      }
    },
    versionSelected (value) {
      this.dataFromQuestions(value, 0)
    },
    goToNextQuestion () {
      this.handleIfEditDecisionQues(0, this.question0)
      this.$store.dispatch('handleScoringData', this.sq_data)
      this.$emit('handleProgress', 20)
      if (this.isBrowsingInScoringHistory) {
        this.$emit('reduceDecreasing', 1)
        this.$store.dispatch('handleOnlyCurrentSQ', 20)
      } else {
        this.$store.dispatch('handleCurrentSQ', 20)
      }
      this.$emit('checkIfHistoryModeContinues')
    }
  },
  mixins: [answerData],
  mounted () {
    this.setData()
  }
}
</script>

<style lang="scss" scoped>
.ques-enter-active {
  transition: opacity .5s;
}
.ques-enter {
  opacity: 0;
}
